import { FormItem } from "@/cs-ts-bridge/ts/form-item";
import { BaseElementDef, BaseElementDefBase } from "./BaseElementDef";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { CompletionRedirectSettings } from "@cs-ts/completion-redirect-settings";
import { CalculationContext } from "./__CalculationContextInterface";

export default class CompletionRedirectDef extends BaseElementDef<CompletionRedirectSettings, FormDefinitionItem<CompletionRedirectSettings>, FormItem> {
    declare isPostSubmitRedirect: true;
    constructor(parentElement: BaseElementDefBase | null, elementData: FormItem, definitionData: FormDefinitionItem<CompletionRedirectSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = "MI.Common.DynamicForms.Models.DFCommonCheckout"; // TODO - not hardcoded?
        this.isPostSubmitRedirect = true;
    }

    shouldSkipConfirm() {
        return this.definition.settings.skipConfirmation ? true : null;
    }

    shouldSkipCompletion() {
        return this.definition.settings.skipCompletion;
    }

    getPostSubmitRedirect() {
        if (this.definition.settings.redirectUrlCalculationId != null) {
            const result = this.resolveCalculationPromise(this.definition.settings.redirectUrlCalculationId, this.definition.settings.legacyRedirectUrlCalculation);
            return result;
        } else {
            return this.definition.settings.redirectUrl;
        }
    }
}
